export default __webpack_public_path__ + "static/media/gf1200.10a5912c.png";